import React from 'react';
import PropTypes from 'prop-types';
import { ColumnExportButton, Table } from 'barnyard/components';
import { format_dollars } from '~/app/common/utils';


const DEAItemsTable = ({ items, includeExport }) => {
  const columns = [{
    Header: 'Vetcove ID',
    accessor: 'id',
  }, {
    Header: 'DEA Schedule',
    accessor: 'dea_schedule',
  }, {
    Header: 'Name',
    accessor: 'name',
  }, {
    Header: 'Quantity',
    accessor: 'quantity',
  }, {
    Header: 'Unit Price',
    id: 'unit_price',
    accessor: row => `${format_dollars({ integer: row.unit_price, include_cents: true })}`,
  }, {
    Header: 'Total Price',
    id: 'total_price',
    accessor: row => `${format_dollars({ integer: row.total_price, include_cents: true })}`
  }];

  return (
    <Table
      actions={includeExport && (
        <div className='u-paddingTop10'>
          <ColumnExportButton
            columns={columns}
            data={items}
            filename='Vetcove_DEA_Items_Table.csv'
          >
            Download
          </ColumnExportButton>
        </div>
      )}
      size='small'
      columns={columns}
      data={items}
      pageSize={items.length || 10}
      showPagination={false}
    />
  );
};

DEAItemsTable.propTypes = {
  items: PropTypes.array.isRequired,
  includeExport: PropTypes.bool
};

export default DEAItemsTable;
